import React, { Component } from 'react';
import { IonButton } from '@ionic/react';
import app from 'src/feathers';
import programming from 'src/images/programming.svg';
const sentry = app.get('sentryClient');

export default class ErrorBoundry extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    sentry.captureException(error, { extra: errorInfo });
  }
  openDialog = () => {
    sentry.showReportDialog(this.state.error);
  };
  render() {
    if (this.state.error) {
      return (
        <div className="text-center d-flex align-items-center p-3 h-100vh animated fadeIn fast">
          <div>
            <img
              src={programming}
              className="img-fluid mb-5"
              alt="We are working on a fix!"
            />
            <h3>We're sorry — something's gone wrong.</h3>
            <p className="lead">
              Our team has been notified with details about the error. If you
              would like to give us some more feedback about what happened,
              please fill out an error report.
            </p>
            <IonButton className="mr-3" onClick={this.openDialog}>
              Error Report
            </IonButton>
            <IonButton href="/">Return to Dashboard</IonButton>
          </div>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}
